/**
 * Bundle Accessories Unified Logic
 * 1. 支持直接读取 Liquid 渲染的价格字符串 (data-price-string)
 * 2. 修复 Swatch 状态保持逻辑：点击大框不重置用户已选的变体
 * 3. 完美兼容赠品模式与普通配件模式
 */

var cartData = {}; 

(function() {
  function initAccessoryGroups() {
    const accessoryItems = document.querySelectorAll('.bundled-accessory-item');
    if (!accessoryItems.length) return;

    // --- 内部工具函数：同步赠品数据 ---
    function syncFreeGifts(item, isAdd) {
      const freeIdsStr = item.getAttribute('data-free-ids');
      const productInput = item.querySelector('.bundled_product_input');
      if (!productInput) return;
      const baseIndex = parseInt(productInput.getAttribute('data-value'));
      if (!freeIdsStr || freeIdsStr.trim() === "") return;
      const ids = freeIdsStr.split(',').filter(id => id.trim() !== "");
      if (isAdd) {
        ids.forEach((id, index) => {
          const giftKey = (baseIndex * 100) + index; 
          cartData[giftKey] = { "id": parseInt(id), "quantity": 1, "_isFree": true };
        });
      } else {
        Object.keys(cartData).forEach(key => {
            const numKey = parseInt(key);
            if (numKey >= baseIndex * 100 && numKey < (baseIndex + 1) * 100) { delete cartData[key]; }
        });
      }
    }

    // --- 核心更新 UI 函数 ---
    function updateState(item, isSwitchingProduct = false, targetRadio = null) {
      const productInputDiv = item.querySelector('.bundled_product_input');
      const qtyInput = item.querySelector('.qty-input');
      const freeIdsStr = item.getAttribute('data-free-ids');
      const isGiftMode = freeIdsStr && freeIdsStr.trim().length > 0;
      
      const isActive = item.classList.contains('bundled_product_input_act');
      const activeRadio = targetRadio || item.querySelector('.accessory-radio:checked');
      
      if (!productInputDiv) return;
      if (!isGiftMode && !activeRadio) return;

      const targetIndex = productInputDiv.getAttribute('data-value');

      // 更新文本预览 (价格/名称)
      if (isSwitchingProduct) {
        const nameElem = item.querySelector('.selected-name');
        const regElem = item.querySelector('.regular-price');
        const compElem = item.querySelector('.compare-price');
        const saveElem = item.querySelector('.save-amount');
        const priceContainer = item.querySelector('.price-container');

        if (isGiftMode) {
            if (nameElem) nameElem.textContent = "Free";
            if (regElem) regElem.textContent = "Free";
            const giftCompareStr = item.getAttribute('data-compare-string'); 
            if (giftCompareStr) {
              priceContainer?.classList.add('has-discount');
              if (compElem) { compElem.textContent = giftCompareStr; compElem.style.display = 'inline'; }
              if (saveElem) { saveElem.textContent = "SAVE " + giftCompareStr; saveElem.style.display = 'block'; }
            }
        } else if (activeRadio) {
            productInputDiv.setAttribute('data-id', activeRadio.value);
            if (nameElem) nameElem.textContent = activeRadio.getAttribute('data-product-title');

            // 直接读取 Liquid 渲染好的字符串
            const priceStr = activeRadio.getAttribute('data-price-string');
            const compareStr = activeRadio.getAttribute('data-compare-string');
            const saveStr = activeRadio.getAttribute('data-save-string');

            if (regElem) regElem.textContent = priceStr;
            if (compareStr) {
              priceContainer?.classList.add('has-discount');
              if (compElem) { compElem.textContent = compareStr; compElem.style.display = 'inline'; }
              if (saveElem) { saveElem.textContent = saveStr; saveElem.style.display = 'block'; }
            } else {
              priceContainer?.classList.remove('has-discount');
              if (compElem) compElem.style.display = 'none';
              if (saveElem) saveElem.style.display = 'none';
            }
        }
      }

      // 同步数据到全局 cartData 对象
      if (isActive) {
        if (isGiftMode) {
            if (cartData[targetIndex]) delete cartData[targetIndex];
            syncFreeGifts(item, true);
        } else if (activeRadio) {
            const re_product_id = parseInt(activeRadio.value);
            const quantity_int = parseInt(qtyInput?.value) || 1;
            cartData[targetIndex] = { "id": re_product_id, "quantity": quantity_int, "_isFree": false };
        }
      }
    }

    // --- 初始化绑定 ---
    accessoryItems.forEach(item => {
      // 初始渲染状态
      if (item.classList.contains('bundled_product_input_act')) { updateState(item, true); }
      
      // Swatch 切换监听
      item.querySelectorAll('.accessory-radio').forEach(radio => {
        radio.addEventListener('change', function() { 
          updateState(item, true, this); 
        });
      });

      // 数量增减监听
      const qtyInput = item.querySelector('.qty-input');
      const plusBtn = item.querySelector('.qty-btn.plus');
      const minusBtn = item.querySelector('.qty-btn.minus');
      if (plusBtn && minusBtn && qtyInput) {
        plusBtn.onclick = (e) => {
            e.preventDefault();
            qtyInput.value = parseInt(qtyInput.value) + 1;
            updateState(item);
        };
        minusBtn.onclick = (e) => {
            e.preventDefault();
            if (parseInt(qtyInput.value) > 1) {
                qtyInput.value = parseInt(qtyInput.value) - 1;
                updateState(item);
            }
        };
      }
    });

    // --- 勾选框点击监听 (修复重置逻辑) ---
    document.addEventListener('click', function(e) {
      const inputBtn = e.target.closest('.bundled_product_input');
      if (!inputBtn) return;
      const item = inputBtn.closest('.bundled-accessory-item');
      if (!item) return;

      item.classList.toggle('bundled_product_input_act');
      const isActive = item.classList.contains('bundled_product_input_act');
      const targetIndex = inputBtn.getAttribute('data-value');
      const freeIdsStr = item.getAttribute('data-free-ids');
      const isGiftMode = freeIdsStr && freeIdsStr.trim().length > 0;

      if (isActive) {
        if (!isGiftMode) {
            // 检查当前是否有选中的变体
            const checkedRadio = item.querySelector('.accessory-radio:checked');
            if (!checkedRadio) {
                // 只有没选过时才默认选第一个
                const firstRadio = item.querySelector('.accessory-radio');
                if (firstRadio) {
                    firstRadio.checked = true;
                    firstRadio.dispatchEvent(new Event('change', { bubbles: true }));
                }
            } else {
                // 如果已经有选中的变体，保持不变并更新数据
                updateState(item, true, checkedRadio);
            }
        } else {
            updateState(item, true);
        }
      } else {
        // 取消勾选：仅清除购物车数据，不清除 Radio 选中状态，方便用户下次勾选
        delete cartData[targetIndex];
        syncFreeGifts(item, false);
      }
    });
  }

    // UI 重置工具：确保彻底清除选中状态
    function resetAllUI() {
        const activeItems = document.querySelectorAll('.bundled-accessory-item.bundled_product_input_act');
        activeItems.forEach(item => {
            item.classList.remove('bundled_product_input_act');
            
            // --- 核心修改：重置时取消所有 Radio 的选中状态 ---
            const radios = item.querySelectorAll('.accessory-radio');
            radios.forEach(r => {
                r.checked = false;
            });
            
            // 同时重置文字预览到默认（可选，视你需求而定）
            const nameElem = item.querySelector('.selected-name');
            // if (nameElem) nameElem.textContent = "..."; 
        });
        
        // 重置所有数量
        document.querySelectorAll('.qty-input').forEach(input => { input.value = 1; });
    }

  // --- 启动逻辑 ---
  document.addEventListener('DOMContentLoaded', initAccessoryGroups);
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAccessoryGroups);
  }

  // --- 加购逻辑 (Ajax POST) ---
  document.addEventListener('click', function(event) {
    const addBtn = event.target.closest('.button_add');
    if (!addBtn) return;
    if (addBtn.classList.contains('loading')) return;

    const mainForm = addBtn.closest('form') || document;
    const mainId = parseInt(mainForm.querySelector("input[name='id']")?.value);
    const mainQty = parseInt(mainForm.querySelector("input[name='quantity']")?.value || 1);
    
    if (!mainId) return;
    event.preventDefault();

    let finalItemsToSubmit = [];
    for (let i = 0; i < mainQty; i++) {
        const bundleBindingID = generateShortId(10); 
        finalItemsToSubmit.push({
            "id": mainId, "quantity": 1,
            "properties": { "Binding": bundleBindingID, "Product_Status": "Main_products", "_Main_products": bundleBindingID }
        });
        Object.keys(cartData).forEach(key => {
            const itemData = cartData[key];
            const isGift = itemData._isFree ? "Gift_products" : "Accessory_products";
            finalItemsToSubmit.push({
                "id": itemData.id, "quantity": itemData.quantity,
                "properties": { "Binding": bundleBindingID, "Product_Status": isGift, "_Main_products": bundleBindingID }
            });
        });
    }
    addProductArr(finalItemsToSubmit, addBtn);
  });

  function addProductArr(items, btn) {
    if (btn) { btn.classList.add('loading'); btn.disabled = true; }
    const sectionsToBundle = ["variant-added"];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
    const qs = new URLSearchParams({ sections: sectionsToBundle.join(","), sections_url: window.Shopify.routes.root + "variants/" + items[0].id });
    fetch(window.Shopify.routes.root + 'cart/add.js?' + qs.toString(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ "items": items })
    })
    .then(async (response) => {
      if (response.ok) {
        if (window.location.pathname.includes('/cart')) { window.location.reload(); }
        else {
            const responseJson = await response.json();
            const cartContent = await (await fetch(window.Shopify.routes.root + 'cart.js')).json();
            cartContent["sections"] = responseJson["sections"];
            document.documentElement.dispatchEvent(new CustomEvent("variant:add", { bubbles: true, detail: { items: responseJson.items || [responseJson], cart: cartContent } }));
            document.documentElement.dispatchEvent(new CustomEvent("cart:change", { bubbles: true, detail: { baseEvent: "variant:add", cart: cartContent } }));
            cartData = {};
            resetAllUI();
        }
      } else {
        const errorData = await response.json();
        alert('Error: ' + errorData.description);
      }
    })
    .finally(() => { if (btn) { btn.classList.remove('loading'); btn.disabled = false; } });
  }

  // --- 其他功能：展开折叠、随机ID ---
  document.addEventListener('click', (e) => {
    // 找到点击的按钮
    const btn = e.target.closest('.bundled_accessories_fold_cm');
    if (!btn) return;

    // 找到按钮上方的容器
    // 注意：假设按钮是紧跟在 container 后面的兄弟元素，或者在同一个父级下
    // 这里使用 previousElementSibling 查找比较稳妥，或者通过共同父级查找
    const wrapper = btn.closest('section') || btn.parentElement; 
    const container = wrapper.querySelector('.bundled-accessories-unified-container');
    
    const btnText = btn.querySelector('span');

    if (!container || !btnText) return;

    // 切换展开/折叠状态
    const isExpanded = container.classList.toggle('is-expanded');
    btn.classList.toggle('is-active');

    // 切换文字
    btnText.innerText = isExpanded ? 'show less' : 'show more';
    
    // 改变箭头方向 (CSS已处理 transform，这里不需要额外 JS 操作 style)
  });

  function generateShortId(length = 10) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let result = '';
    for (let i = 0; i < length; i++) { result += chars.charAt(Math.floor(Math.random() * chars.length)); }
    return result;
  }
  // --- 购物车精准删除逻辑 ---
  document.addEventListener('click', function(e) {
    const removeBtn = e.target.closest('.js-remove-bundle');
    if (!removeBtn) return;
    
    e.preventDefault();
    const bindingId = removeBtn.getAttribute('data-binding');
    if (!bindingId) return;

    const row = removeBtn.closest('.line-item') || removeBtn.closest('tr') || removeBtn.closest('.cart-item');
    if (row) row.style.opacity = '0.5';

    // 获取当前购物车详情
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(res => res.json())
      .then(cart => {
        const updates = {};
        cart.items.forEach(item => {
          // 只有 Binding ID 匹配时才处理
          if (item.properties && item.properties.Binding === bindingId) {
            const status = item.properties['Product_Status'];
            
            // --- 核心逻辑修改区 ---
            // 只有是 主产品 或 赠品 时，才设为 0 (删除)
            if (status === 'Main_products' || status === 'Gift_products') {
              updates[item.key] = 0;
            } 
            // 如果是 Accessory_products，不加入 updates 列表，它就会被保留在购物车
          }
        });

        // 执行更新请求
        return fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(() => {
        // 刷新页面以看到变化
        if (window.location.pathname.includes('/cart')) {
          window.location.reload();
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
      })
      .catch(err => {
        console.error('Delete error:', err);
        if (row) row.style.opacity = '1';
      });
  });
})();
(function() {
    function injectKlarnaStyles(el) {
        // 如果已经处理过，直接跳过
        if (el.dataset.klarnaStyled === '1') return;

        const shadow = el.shadowRoot;
        // 如果 shadowRoot 还不存在，说明组件还没初始化好
        if (!shadow) return;

        // 检查 shadowRoot 内部是否已经有内容了，有时候 shadow 存在但里面是空的
        if (shadow.children.length === 0) return;

        const style = document.createElement('style');
        // 添加 !important 确保覆盖内部默认样式
        style.textContent = `
            .credit-promotion-badge .container { border: 0px !important; padding: 0px !important; }
            .badge-container .badge { max-width: 50px !important; }
            @media (max-width: 960px) {
                .checkout-container .checkout-main-text { flex: auto !important; }
                .credit-promotion-badge .container { }
                .credit-promotion-badge .badge-container { justify-content: left !important; }
                .credit-promotion-badge .text-wrapper { margin-top: 0px !important; }
            }
        `;
        shadow.appendChild(style);
        el.dataset.klarnaStyled = '1';
        console.log('Klarna style injected successfully!');
    }

    // 使用更频繁的检查逻辑，针对 Shadow Root 的特殊性
    const observer = new MutationObserver((mutations) => {
        const elements = document.querySelectorAll('klarna-placement[data-key*="credit-promotion-badge"]');
        elements.forEach(el => {
            // 持续尝试注入，直到成功（dataset 标记会阻止重复注入）
            injectKlarnaStyles(el);
        });
    });

    observer.observe(document.body, { 
        childList: true, 
        subtree: true,
        attributes: true // 增加属性监听，有些插件会动态修改属性
    });

    // 初始执行一次
    document.querySelectorAll('klarna-placement[data-key*="credit-promotion-badge"]').forEach(injectKlarnaStyles);
})();